import { IconEdit, IconTrash } from "@tabler/icons-react"
import { type FC } from "react"
import { useDropzone } from "react-dropzone"

import { getDataUrlByFile } from "@forento/core/utilities/file"

import { query } from "~/utilities/trpc"

type Props = { course: { id: string; thumbnailUrl: string | null }; reload(): Promise<unknown> }
const Thumbnail: FC<Props> = ({ course, reload }) => {
	const updateCourse = query.updateCourse.useMutation({
		onSuccess: () => reload(),
		onError(error) {
			console.error(error)
		},
	})

	const { getRootProps, getInputProps, open } = useDropzone({
		accept: { "image/*": [".png", ".jpg", ".jpeg"] },
		async onDrop(files) {
			const file = files[0]
			if (file === undefined) return

			const base64 = await getDataUrlByFile(file)
			updateCourse.mutate({ id: course.id, thumbnailBase64: base64 })
		},
	})

	if (course.thumbnailUrl) {
		return (
			<div className="group relative">
				<input {...getInputProps()} />
				<img
					src={course.thumbnailUrl}
					alt="Kursbild"
					className="aspect-video w-64 rounded-lg border-2 border-slate-200 object-cover shadow-sm"
				/>
				<div className="absolute inset-0 flex items-center justify-center gap-2 rounded-lg bg-black/0 transition-colors group-hover:bg-black/20">
					<button
						type="button"
						className="flex cursor-pointer items-center gap-1.5 rounded bg-black/70 px-3 py-1 text-sm font-medium text-white opacity-0 transition-opacity group-hover:opacity-100 hover:bg-black/80"
						onClick={open}
					>
						<IconEdit className="size-3.5" /> Ändra
					</button>
					<button
						type="button"
						className="flex cursor-pointer items-center gap-1.5 rounded bg-red-600/90 px-3 py-1 text-sm font-medium text-white opacity-0 transition-opacity group-hover:opacity-100 hover:bg-red-700"
						onClick={() => updateCourse.mutate({ id: course.id, thumbnailBase64: null })}
					>
						<IconTrash className="size-3.5" /> Ta bort
					</button>
				</div>
			</div>
		)
	}

	return (
		<div
			className="group relative flex aspect-video w-64 cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-slate-300 bg-slate-50"
			{...getRootProps()}
		>
			<input {...getInputProps()} />
			<div className="text-center text-sm text-slate-500">Lägg till kursbild</div>
		</div>
	)
}

export default Thumbnail
